import ReactApexChart from "react-apexcharts";
import { Typography } from "antd";

function EChart({
  eChartData,
}) {
  const { Title, Paragraph } = Typography;

  return (
    <>
      <div id="chart">
        <ReactApexChart
          className="bar-chart"
          options={eChartData.options}
          series={eChartData.series}
          type="bar"
          height={300}
        />
      </div>
      <div className="chart-vistior">
        <Title level={5}>Total Workload (all labs) in the Past 12 months</Title>
        <Paragraph className="lastweek">
          These are the aggregated workloads of all laboratories at NPHL.
        </Paragraph>
      </div>
    </>
  );
}

export default EChart;
